const state = {
  isOpen: true
}

const actions = {
  open ({ commit }) {
    commit('open')
  },

  close ({ commit }) {
    commit('close')
  },

  toggle ({ commit }) {
    commit('toggle')
  }
}

const mutations = {
  open ({ commit }) {
    state.isOpen = true
  },

  close ({ commit }) {
    state.isOpen = false
  },

  toggle ({ commit }) {
    state.isOpen = !state.isOpen
  }
}

const mainMenu = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default mainMenu
